export const TABLE = {
  CSV: 1,
  BACKEND: 2,
};

export const columnTitles = [
  {
    title: 'Id',
    dataIndex: 'id',
    hideOn: TABLE.BACKEND,
  },
  {
    title: 'Thông tin lead',
    dataIndex: 'name',
  },
  {
    title: 'Nguồn',
    dataIndex: 'source',
  },
  {
    title: 'Quận',
    dataIndex: 'district_name',
    hideOn: TABLE.BACKEND,
  },
  {
    title: 'Địa chỉ',
    dataIndex: 'city_name',
  },
  {
    title: 'Loại xe',
    dataIndex: 'vhc_type_name',
  },
  {
    title: 'Ngày thuê',
    dataIndex: 'rental_date',
  },
  {
    title: 'Ngày trả',
    dataIndex: 'return_date',
  },
  {
    title: 'Xe',
    dataIndex: 'vhc_name',
  },
  {
    title: 'Mục đích thuê',
    dataIndex: 'renting_purpose',
    hideOn: TABLE.BACKEND,
  },
  {
    title: 'Lịch trình',
    dataIndex: 'schedule',
    hideOn: TABLE.BACKEND,
  },
  {
    title: 'Ghi chú',
    dataIndex: 'note',
    hideOn: TABLE.BACKEND,
  },
  {
    title: 'Trạng thái',
    dataIndex: 'status',
  },
  {
    title: 'Lý do fail',
    dataIndex: 'failure_reason',
  },
  {
    title: 'Ghi chú call',
    dataIndex: 'call_note',
    hideOn: TABLE.BACKEND,
  },
];
